var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuyWithCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "6px",
    viewBox: "0 0 7 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E2C22D09-1901-4557-806A-A4049E8750E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview---GMS",
    transform: "translate(-168.000000, -217.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,136.6 C18.3054153,136.6 18.9583333,137.271573 18.9583333,138.1 L18.9583333,138.1 L18.9583333,138.7 C18.9583333,138.865685 18.8277497,139 18.6666667,139 C18.5055836,139 18.375,138.865685 18.375,138.7 L18.375,138.7 L18.375,138.1 C18.375,137.602944 17.9832492,137.2 17.5,137.2 L17.5,137.2 L15.4583333,137.2 C14.9750842,137.2 14.5833333,137.602944 14.5833333,138.1 L14.5833333,138.1 L14.5833333,138.7 C14.5833333,138.865685 14.4527497,139 14.2916667,139 C14.1305836,139 14,138.865685 14,138.7 L14,138.7 L14,138.1 C14,137.271573 14.6529181,136.6 15.4583333,136.6 L15.4583333,136.6 Z M20.5020939,134.887868 C20.6159968,134.770711 20.8006699,134.770711 20.9145728,134.887868 C21.0284757,135.005025 21.0284757,135.194975 20.9145728,135.312132 L20.9145728,135.312132 L19.7479061,136.512132 C19.6340032,136.629289 19.4493301,136.629289 19.3354272,136.512132 L19.3354272,136.512132 L18.7520939,135.912132 C18.6381909,135.794975 18.6381909,135.605025 18.7520939,135.487868 C18.8659968,135.370711 19.0506699,135.370711 19.1645728,135.487868 L19.1645728,135.487868 L19.5416667,135.875736 Z M16.4791667,133 C17.2845819,133 17.9375,133.671573 17.9375,134.5 C17.9375,135.328427 17.2845819,136 16.4791667,136 C15.6737514,136 15.0208333,135.328427 15.0208333,134.5 C15.0208333,133.671573 15.6737514,133 16.4791667,133 Z M16.4791667,133.6 C15.9959175,133.6 15.6041667,134.002944 15.6041667,134.5 C15.6041667,134.997056 15.9959175,135.4 16.4791667,135.4 C16.9624158,135.4 17.3541667,134.997056 17.3541667,134.5 C17.3541667,134.002944 16.9624158,133.6 16.4791667,133.6 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyWithCheckmark);
export default __webpack_public_path__ + "static/media/guy-with-checkmark.4e4210e3a7f2b8619e521fa0b77a8f77.svg";
export { ForwardRef as ReactComponent };